import React from 'react';

import {BootstrapModuleController} from "../bootstrap-module.controller";
import {IOC} from "../../../infrastructure/ioc";

export const BootstrapModuleComposer = (BootstrapModule) => ((props) => {
  const controller: BootstrapModuleController = new BootstrapModuleController(props);
  const ioc: IOC = props.ioc;

  const providerProps = {
    ioc,
    controller,
  }

  const appModuleProps = {
    ioc,
    params: controller.settings,
    config: controller.config
  }

  const bootstrapModuleProps = {
    controller,
    providerProps,
    appModuleProps,
  }

  return <BootstrapModule {...bootstrapModuleProps} />
});
